import {
  AnalyticsClientSendEventHook,
  buildInteractiveResult,
  InteractiveResult,
  Result,
  SearchEngine
} from '@coveo/headless';
import { createContext, useCallback, useContext, useMemo } from 'react';

export class ResultActionAnalytics {
  pendingAction = null;

  getAnalyticsMiddleware() {
    return (_, payload) => {
      if (!this.pendingAction) {
        return payload;
      }
      if (payload.actionCause !== 'documentOpen') {
        return payload;
      }
      payload.customData = {
        ...payload.customData,
        resultAction: this.pendingAction
      };
      this.pendingAction = null;
      return payload;
    };
  }

  setPendingAction(newPendingAction) {
    this.pendingAction = newPendingAction;
  }
}
const ResultActionAnalyticsContext = createContext(null);

export const ResultActionAnalyticsProvider =
  ResultActionAnalyticsContext.Provider;

export function useResultActionInteractiveResult({
  engine,
  result,
  actionName
}) {
  const resultActionAnalytics = useContext(ResultActionAnalyticsContext);
  const interactiveResult = useMemo(
    () => buildInteractiveResult(engine, { options: { result } }),
    [engine, result]
  );
  const updatePendingAction = useCallback(() => {
  }, [resultActionAnalytics, actionName]);

  return {
    select() {
      updatePendingAction();
      interactiveResult.select();
    },
    beginDelayedSelect() {
      updatePendingAction();
      interactiveResult.beginDelayedSelect();
    },
    cancelPendingSelect() {
      interactiveResult.cancelPendingSelect();
    }
  };
}
